let openReportVocSeriesUploadHandler: (() => void) | null = null;

export const registerOpenReportVocSeriesUpload = (fn: () => void) => {
  openReportVocSeriesUploadHandler = fn;
  return () => {
    openReportVocSeriesUploadHandler = null;
  };
};

export const openReportVocSeriesUpload = () => {
  openReportVocSeriesUploadHandler?.();
};
